import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logoSrc from "../../Assets/Images/jnto_logo_new.png";
import {
  AIBotIcon,
  SettingsIcon,
  ChannelIcon,
  ChatIcon,
  GroupIcon,
} from "./icons";
import { useDispatch, useSelector } from "react-redux";
import profile_Img from "../../Assets/Images/user.png";
import { converId } from "../../Redux/slices/ChatSlice";

export default function MiniSideBar({
  otherChannelChatMsg,
  setOtherChannelChatMsg,
}) {
  const { userInfo } = useSelector((state) => state.authUser);

  const menuItems = [
    {
      isActive: window.location.pathname.includes("/home"),
      hasNewMsg: otherChannelChatMsg.chat,
      Icon: ChatIcon,
      label: "Chats",
      path: "/home",
      onClick: () =>
        setOtherChannelChatMsg((otherChannelChatMsg) => ({
          ...otherChannelChatMsg,
          chat: false,
        })),
    },
    {
      isActive: window.location.pathname.includes("/groups"),
      hasNewMsg: otherChannelChatMsg.group,
      Icon: GroupIcon,
      label: "Groups",
      path: "/groups",
      onClick: () =>
        setOtherChannelChatMsg((otherChannelChatMsg) => ({
          ...otherChannelChatMsg,
          group: false,
        })),
    },
    // { Icon: AIBotIcon, label: "AI Bot", path: "/aibot" },
    {
      isActive: window.location.pathname.includes("/channels"),
      hasNewMsg: otherChannelChatMsg.channel,
      Icon: ChannelIcon,
      label: "Channels",
      path: "/channels",
      onClick: () =>
        setOtherChannelChatMsg((otherChannelChatMsg) => ({
          ...otherChannelChatMsg,
          channel: false,
        })),
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const isSettingsActive = location.pathname.startsWith("/settings"); // Check if any settings route is active
  const dispatch = useDispatch();

  return (
    <div className="w-full px-6 flex flex-col items-center py-5">
      {/* Logo - JNTO Infinity Symbol */}
      <div className="mb-6">
        <img
          src={logoSrc}
          alt="JNTO"
          className="w-10 h-10 object-contain"
        />
      </div>

      {/* Menu Items */}
      <nav className="flex flex-col gap-6 pt-8 w-full">
        {menuItems.map(({ Icon, label, path, isActive, onClick, hasNewMsg }) => {
          return (
            <div
              onClick={() => {
                if (isActive) {
                  return;
                }
                onClick();
                dispatch(converId(""));
                navigate(path);
              }}
              key={path}
              className="flex items-center flex-col cursor-pointer relative"
            >
              {!isActive && hasNewMsg && (
                <div className="absolute top-1.5 right-6 w-2 h-2 rounded-full bg-green-500 z-[9999]"></div>
              )}
              <div
                className={`flex flex-col items-center py-3 px-3 w-[42px] h-[42px] rounded-xl transition-all 
                ${isActive
                    ? "bg-purple-500/10 text-purple-600"
                    : "text-gray-500 hover:text-primary"
                  }`}
              >
                <Icon isActive={isActive} />
              </div>
              <span className="cursor-pointer hover:text-purple-600 text-xs font-medium text-black dark:text-zinc-100 mt-1">
                {label}
              </span>
            </div>
          );
        })}
      </nav>
      {/* Settings */}
      <div
        onClick={() => {
          if (isSettingsActive) {
            return;
          }
          dispatch(converId(""));
          navigate("/settings");
        }}
        className="mt-auto flex flex-col items-center mb-6 cursor-pointer"
      >
        <div
          className={`flex flex-col items-center cursor-pointer py-3 px-3 w-[42px] h-[42px] rounded-xl transition-all 
          ${isSettingsActive
              ? "bg-purple-500/10 text-purple-600"
              : "text-gray-500 hover:text-primary"
            }`}
        >
          <SettingsIcon isActive={isSettingsActive} />
        </div>
        <span className="cursor-pointer hover:text-purple-600 text-xs font-medium text-black dark:text-zinc-100 mt-2">
          Settings
        </span>
      </div>

      <div className="mb-2">
        <img
          src={
            userInfo?.avtarImage ||
            userInfo?.userImage ||
            userInfo?.userMedia ||
            profile_Img
          }
          alt="User Avatar"
          className="w-12 h-12 rounded-full border-2 object-cover border-gray-300 hover:border-primary transition-all"
        />
      </div>
    </div>
  );
}
